<template>
  <div class="track-card card" :class="{ readonly: readonly }">
    <div class="card-bd">
      <div class="track-hd">
        <span class="track-icon cs">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ><path d="M12 2L4 5v6c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5z" /><path d="m9 12 2 2 4-4" /></svg>
        </span>
        <div>
          <h4>客服审核环 · 资质与信息核验</h4>
          <p>系统预检项已自动打勾，人工核验需求真实性</p>
        </div>
        <el-tag v-if="!readonly" size="mini" type="primary" effect="plain" style="margin-left:auto">您的审核轨</el-tag>
      </div>

      <template v-if="status === 'CS'">
        <div
          v-for="item in items"
          :key="item.key"
          class="chk-item"
          :class="{ pass: item.pass }"
          @click="!readonly && toggleItem(item)"
        >
          <span class="chk-box">{{ item.pass ? '✓' : '' }}</span>
          <div><div class="chk-label">{{ item.label }}</div><div class="chk-hint">{{ item.hint }}</div></div>
        </div>
      </template>

      <template v-else-if="status === 'RISK' || status === 'RUN' || (status === 'FIX' && !isDocFix)">
        <div class="audit-rec ok"><span class="ar-dot">✓</span><div><b>已通过</b> · 客服审核<span class="ar-meta">证照交叉核验一致，运输需求与行业/线路/货物匹配，尽调材料抽查可信</span></div></div>
        <div class="ar-sub">4 项核验全部通过（2 项系统预检 + 2 项人工确认）</div>
      </template>

      <template v-else-if="status === 'FIX' && isDocFix">
        <div class="audit-rec err"><span class="ar-dot">↩</span><div><b>已退回市场端整改</b> · 客服审核<span class="ar-meta">营业执照影像模糊或法人身份证过期，已退回要求重新上传</span></div></div>
        <div class="ar-sub">客户重新提交后自动回到客服审核队列，无需重新开通账号</div>
      </template>

      <template v-else>
        <div class="stage-lock"><b>待开启</b>客服审核通过后自动进入本环节，流转时站内消息提醒</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "CsTrack",
  props: {
    applyCode: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    ddData: { type: Object, default: null },
    status: { type: String, default: "" }
  },
  data() {
    return {
      items: [
        { key: "cert", label: "证件一致性（系统预检）", hint: "执照/法人/管理员身份证 OCR 交叉比对一致", pass: true },
        { key: "face", label: "人脸活体核验（系统预检）", hint: "比对分值≥80为通过", pass: true },
        { key: "match", label: "运输需求与实际匹配度", hint: "行业与线路/货物/吨位是否自洽", pass: false },
        { key: "dd_spot", label: "尽调材料可信度抽查", hint: "水印照片定位一致性、佐证文件形式审查", pass: false }
      ]
    };
  },
  computed: {
    isDocFix() {
      return this.status === "FIX" && this.ddData === null;
    }
  },
  methods: {
    toggleItem(item) { item.pass = !item.pass; },
    getResult() { return this.items.every(i => i.pass); }
  }
};
</script>

<style lang="scss" scoped>
.track-card {
  &.readonly { opacity: 0.6; pointer-events: none; }
  .card-bd { padding: 14px; }
  .track-hd { display: flex; align-items: center; gap: 10px; padding-bottom: 12px; border-bottom: 1px solid var(--line2); margin-bottom: 12px; }
  .track-hd h4 { font-size: 14px; font-weight: 700; margin: 0; color: var(--ink); }
  .track-hd p { font-size: 12px; color: var(--ink3); margin: 2px 0 0; }
  .track-icon { width: 32px; height: 32px; border-radius: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .track-icon.cs { background: rgba(2,132,199,0.1); color: #0284c7; }
  .chk-item { display: flex; align-items: flex-start; gap: 10px; padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 10px; margin-bottom: 8px; font-size: 12px; cursor: pointer; transition: 0.14s; background: #fff; }
  .chk-item:hover { border-color: #cbd5e1; }
  .chk-item.pass { border-color: #a7f3d0; background: #ecfdf5; }
  .chk-box { width: 17px; height: 17px; border-radius: 5px; border: 1.5px solid #c9d2e0; flex-shrink: 0; display: flex; align-items: center; justify-content: center; font-size: 11px; color: #fff; margin-top: 1px; }
  .chk-item.pass .chk-box { background: #10b981; border-color: #10b981; }
  .chk-label { font-size: 12px; font-weight: 600; color: var(--ink); }
  .chk-hint { font-size: 11px; color: var(--ink4); margin-top: 2px; }
  .audit-rec { display: flex; gap: 10px; align-items: flex-start; border-radius: 10px; padding: 11px 13px; font-size: 12.5px; line-height: 1.65; margin-bottom: 12px; }
  .audit-rec.ok { background: #FBFFFD; border: 1px solid #BFE3D6; }
  .audit-rec.err { background: #FFFAFA; border: 1px solid #FFCCC7; }
  .ar-dot { width: 20px; height: 20px; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 11px; font-weight: 700; }
  .audit-rec.ok .ar-dot { background: #10b981; color: #fff; }
  .audit-rec.err .ar-dot { background: #ef4444; color: #fff; }
  .ar-meta { display: block; color: #94a3b8; font-size: 11px; font-weight: 400; margin-top: 2px; }
  .ar-sub { font-size: 10px; color: #94a3b8; }
  .stage-lock { border: 1.5px dashed #e2e8f0; border-radius: 11px; padding: 22px 16px; text-align: center; color: #94a3b8; font-size: 12.5px; background: #FAFBFC; }
  .stage-lock b { display: block; font-size: 13px; color: #64748b; margin-bottom: 5px; }
}
</style>
